import axios, { AxiosError, AxiosResponse, AxiosRequestTransformer } from "axios";
import { JsonApiDocument } from "../../common/ApiSchemaType/Types";
import { getheader, getUrl, setSuccesResponse, setErrorResponse } from "./Script";
import { IRequest, PromiseType, PromiseErrorType } from "./Types";

/**
 * Make axios HTTP request for retrive api response
 * Get and post method autocomplete and parameter typings
 */
export const HttpRequest = {
  get: async (payLoad: IRequest): Promise<JsonApiDocument> =>{
    return new Promise((resolve: PromiseType, reject: PromiseErrorType)=>{
      axios.get(getUrl(payLoad), {
        transformRequest: [(data: any, headers: any): AxiosRequestTransformer => {
          // Deleting the preloaded beare token only for request to s3
          if(payLoad.preSignUrl){
            delete headers.Authorization;
          }
          return data;
        }]
      }).then((response: AxiosResponse) => {
        resolve(setSuccesResponse(response.data));
      }).catch((error: AxiosError) => {
        reject(setErrorResponse(error));
      });
    });
  },
  post: async (payLoad: IRequest): Promise<JsonApiDocument> =>{
    return new Promise((resolve: PromiseType, reject: PromiseErrorType)=>{
      axios.post(getUrl(payLoad), payLoad.request,
        getheader(payLoad)).then((response: AxiosResponse) => {
        resolve(setSuccesResponse(response.data));
      }).catch((error: AxiosError) => {
        reject(setErrorResponse(error));
      });
    });
  },
  patch: async (payLoad: IRequest): Promise<JsonApiDocument> =>{
    return new Promise((resolve: PromiseType, reject: PromiseErrorType)=>{
      axios.patch(getUrl(payLoad), payLoad.request,
        getheader(payLoad)).then((response: AxiosResponse) => {
        resolve(setSuccesResponse(response.data));
      }).catch((error: AxiosError) => {
        reject(setErrorResponse(error));
      });
    });
  },
  put: async (payLoad: IRequest): Promise<JsonApiDocument> =>{
    return new Promise((resolve: PromiseType, reject: PromiseErrorType)=>{
      axios.put(getUrl(payLoad), payLoad.request,
        getheader(payLoad)).then((response: AxiosResponse) => {
        resolve(setSuccesResponse(response.data));
      }).catch((error: AxiosError) => {
        reject(setErrorResponse(error));
      });
    });
  },
  delete: async (payLoad: IRequest): Promise<JsonApiDocument> =>{
    return new Promise((resolve: PromiseType, reject: PromiseErrorType)=>{
      axios.delete(getUrl(payLoad),getheader(payLoad)).then((response: AxiosResponse) => {
        resolve(setSuccesResponse(response.data));
      }).catch((error: AxiosError) => {
        reject(setErrorResponse(error));
      });
    });
  },
  getWithHeader: async (payLoad: IRequest): Promise<JsonApiDocument> =>{
    return new Promise((resolve: PromiseType, reject: PromiseErrorType)=>{
      axios.get(getUrl(payLoad), getheader(payLoad)).then((response: AxiosResponse) => {
        resolve(setSuccesResponse(response.data));
      }).catch((error: AxiosError) => {
        reject(setErrorResponse(error));
      });
    });
  }
};
